import React, { ReactNode } from 'react'
import { InputWrap } from './styles'

interface InputWrapperProps {
  children: ReactNode
  borderColor?: string
  backgroundColor?: string
  outlineColor?: string
}

export const InputWrapper = ({
  children,
  borderColor = '#cecece',
  backgroundColor = '#f7f7f7',
  outlineColor,
}: InputWrapperProps) => {
  return (
    <InputWrap
      bordercolor={borderColor}
      backgroundcolor={backgroundColor}
      outlinecolor={outlineColor}
    >
      {children}
    </InputWrap>
  )
}
